import { Pipe, PipeTransform } from '@angular/core';
import { ContactsFormatter } from '../formatters/contacts/contacts-formatter';

@Pipe({
    name: 'phoneFormat',
    pure: true,
    standalone: true
})
export class PhonePipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        return ContactsFormatter.formatPhone(value);
    }
}
